var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('b-button',{staticClass:"admin-btn",attrs:{"variant":"link"},on:{"click":_vm.goToAdminPanel}},[_c('feather',{staticClass:"mr-2",attrs:{"type":"chevron-left"}}),_c('span',[_vm._v(_vm._s(_vm.$t('adminPanelButton.label')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }